(() => {
  function updateSummary() {
    const summarySection = document.querySelector('.section-pdf-summary');
    if (!summarySection) return;

    // Build map: field_connector value → summary value element
    const map = {};
    summarySection
      .querySelectorAll('[data-field-connector]')
      .forEach((item) => {
        const connector = item.dataset.fieldConnector;
        if (connector) {
          map[connector] = item.querySelector(
            '.section-pdf-summary__item-value',
          );
        }
      });

    // pdf-generate sections
    document
      .querySelectorAll('.section-pdf[data-field-connector]')
      .forEach((section) => {
        const connector = section.dataset.fieldConnector;
        const el = map[connector];
        if (!el) return;

        const checked = section.querySelector('input[type="radio"]:checked');
        el.textContent = checked?.dataset.title || '—';
      });

    // pdf-models section (special — finish|color syntax)
    const models = document.querySelector('component-models');
    if (!models || !models.dataset.fieldConnector) return;

    const [typeConnector, colorConnector] = models.dataset.fieldConnector
      .split('|')
      .map((s) => s.trim());

    // Type (finish): data-type from the selected product slide
    if (typeConnector && map[typeConnector]) {
      const checkedColor = models.querySelector(
        'input[name^="model-select-"]:checked',
      );
      if (checkedColor) {
        const slide = checkedColor.closest('.swiper-slide');
        map[typeConnector].textContent = slide?.dataset.type || '—';
      }
    }

    // Color: checked model-select radio → parent slide data-title
    if (colorConnector && map[colorConnector]) {
      const checkedColor = models.querySelector(
        'input[name^="model-select-"]:checked',
      );
      if (checkedColor) {
        const slide = checkedColor.closest('.swiper-slide');
        map[colorConnector].textContent = slide?.dataset.title || '—';
      }
    }
  }

  document.addEventListener('change', (e) => {
    if (e.target.type === 'radio') updateSummary();
  });

  window.addEventListener('load', updateSummary);

  // ------------------------------------------------------------ //
  // PDF Download
  // ------------------------------------------------------------ //

  function generatePDF() {
    const summarySection = document.querySelector('.section-pdf-summary');
    if (!summarySection) return;

    const logoEl = document.querySelector(
      '.header__heading-logo img, .site-header__logo img, header img[class*="logo"]',
    );
    const footerLogoEl = document.querySelector(
      '.footer__logo-image, .footer__logo img',
    );
    const imageEl = summarySection.querySelector(
      '.section-pdf-summary__image img',
    );
    const footerText =
      summarySection.dataset.pdfFooter?.trim() ||
      summarySection
        .querySelector('.section-pdf-summary__callout')
        ?.textContent?.trim() ||
      '';
    const items = Array.from(
      summarySection.querySelectorAll('[data-field-connector]'),
    ).map((item) => ({
      label:
        item
          .querySelector('.section-pdf-summary__item-label')
          ?.textContent?.trim() || '',
      value:
        item
          .querySelector('.section-pdf-summary__item-value')
          ?.textContent?.trim() || '—',
    }));

    function toDataURL(el, cropAspect, radiusFraction) {
      return new Promise((resolve) => {
        if (!el) return resolve(null);
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = () => {
          const nw = img.naturalWidth;
          const nh = img.naturalHeight;
          let sx = 0,
            sy = 0,
            cw = nw,
            ch = nh;

          if (cropAspect) {
            if (nw / nh > cropAspect) {
              cw = nh * cropAspect;
              sx = (nw - cw) / 2;
            } else {
              ch = nw / cropAspect;
              sy = (nh - ch) / 2;
            }
          }

          const c = document.createElement('canvas');
          c.width = Math.round(cw);
          c.height = Math.round(ch);
          const ctx = c.getContext('2d');

          if (radiusFraction) {
            const r = Math.round(c.height * radiusFraction);
            const w = c.width,
              h = c.height;
            ctx.beginPath();
            ctx.moveTo(r, 0);
            ctx.lineTo(w - r, 0);
            ctx.quadraticCurveTo(w, 0, w, r);
            ctx.lineTo(w, h - r);
            ctx.quadraticCurveTo(w, h, w - r, h);
            ctx.lineTo(r, h);
            ctx.quadraticCurveTo(0, h, 0, h - r);
            ctx.lineTo(0, r);
            ctx.quadraticCurveTo(0, 0, r, 0);
            ctx.closePath();
            ctx.clip();
          }

          ctx.drawImage(img, sx, sy, cw, ch, 0, 0, c.width, c.height);
          resolve({ data: c.toDataURL('image/png'), w: c.width, h: c.height });
        };
        img.onerror = () => resolve(null);
        img.src = el.src + (el.src.includes('?') ? '&' : '?') + '_pdf=1';
      });
    }

    function loadJsPDF() {
      return new Promise((resolve, reject) => {
        if (window.jspdf) return resolve();
        const s = document.createElement('script');
        s.src = 'https://unpkg.com/jspdf@2.5.1/dist/jspdf.umd.min.js';
        s.onload = resolve;
        s.onerror = reject;
        document.head.appendChild(s);
      });
    }

    function loadFonts(src) {
      return new Promise((resolve) => {
        if (window.PDF_FONTS || !src) return resolve();
        const s = document.createElement('script');
        s.src = src;
        s.onload = resolve;
        s.onerror = resolve; // fonts optional — helvetica fallback
        document.head.appendChild(s);
      });
    }

    const PAGE_W = 595.28;
    const PAGE_H = 919.4; // matches the design canvas ratio (taller than A4)
    const PAD = 50;
    const IMG_H = 218;
    const IMG_ASPECT = (PAGE_W - PAD * 2) / IMG_H;

    Promise.all([
      loadJsPDF(),
      toDataURL(logoEl),
      toDataURL(imageEl, IMG_ASPECT, 9.4 / IMG_H),
      toDataURL(footerLogoEl),
      loadFonts(summarySection.dataset.pdfFontsSrc),
    ])
      .then(([, logo, image, footerLogo]) => {
        const headingFont = window.PDF_FONTS?.heading || null;
        const monoFont = window.PDF_FONTS?.mono || null;
        const { jsPDF } = window.jspdf;
        const doc = new jsPDF({
          orientation: 'portrait',
          unit: 'pt',
          format: [PAGE_W, PAGE_H],
        });
        const W = doc.internal.pageSize.getWidth();
        const H = doc.internal.pageSize.getHeight();
        const pad = PAD;
        const contentW = W - pad * 2;

        // Custom fonts — fall back to helvetica if fetch failed
        let FONT_HEADING = 'helvetica';
        let FONT_MONO = 'helvetica';
        if (headingFont) {
          doc.addFileToVFS('AeonikPro-Bold.ttf', headingFont);
          doc.addFont('AeonikPro-Bold.ttf', 'AeonikPro', 'bold');
          FONT_HEADING = 'AeonikPro';
        }
        if (monoFont) {
          doc.addFileToVFS('GTCinetype-Mono.ttf', monoFont);
          doc.addFont('GTCinetype-Mono.ttf', 'GTCinetype', 'normal');
          FONT_MONO = 'GTCinetype';
        }

        // Logo
        if (logo) {
          const lh = 40;
          const lw = lh * (logo.w / logo.h);
          doc.addImage(logo.data, 'PNG', pad, 39, lw, lh);
        } else {
          doc.setFont(FONT_HEADING, 'bold');
          doc.setFontSize(18);
          doc.setTextColor(0);
          doc.text('Powers Electric', pad, 67);
        }

        // HR
        doc.setDrawColor(0);
        doc.setLineWidth(0.5);
        doc.line(pad, 121, W - pad, 121);

        // Title — sized so the longer line spans the content width like the design
        doc.setFont(FONT_HEADING, 'bold');
        let titleSize = 44;
        doc.setFontSize(titleSize);
        while (
          doc.getTextWidth('Summary Of Selections') > contentW &&
          titleSize > 30
        ) {
          titleSize -= 0.5;
          doc.setFontSize(titleSize);
        }
        doc.setTextColor(0);
        doc.text('Pick Your Powers', pad, 191);
        doc.text('Summary Of Selections', pad, 238);

        // Main image
        if (image) {
          doc.addImage(
            image.data,
            'PNG',
            pad,
            265,
            contentW,
            IMG_H,
            undefined,
            'FAST',
          );
        }

        // Items — two columns, filled column by column (left column first)
        const colX = [pad, pad + Math.round(contentW * 0.56)];
        const labelToValue = 26; // label baseline → first value line baseline
        const valueLineH = 25; // extra value lines
        const rowGap = 32; // last value baseline → next label baseline
        const itemsTop = 265 + IMG_H + 42; // first label baseline
        const leftCount = Math.ceil(items.length / 2);

        [items.slice(0, leftCount), items.slice(leftCount)].forEach(
          (colItems, col) => {
            const x = colX[col];
            const maxW = col === 0 ? 210 : W - pad - colX[1] - 12;
            let cy = itemsTop;

            colItems.forEach((item) => {
              doc.setFont(FONT_MONO, 'normal');
              doc.setFontSize(8);
              doc.setTextColor(0);
              doc.text(item.label.toUpperCase(), x, cy, { charSpace: 0.4 });

              doc.setFont(FONT_HEADING, 'bold');
              doc.setFontSize(21);
              doc.setTextColor(0);
              const lines = doc.splitTextToSize(item.value, maxW);
              doc.text(lines, x, cy + labelToValue);

              cy += labelToValue + (lines.length - 1) * valueLineH + rowGap;
            });
          },
        );

        // Footer — pinned to page bottom
        const footY = H - 63;

        doc.setDrawColor(0);
        doc.setLineWidth(0.5);
        doc.line(pad, footY, W - pad, footY);

        if (footerLogo) {
          const fh = 33;
          const fw = fh * (footerLogo.w / footerLogo.h);
          doc.addImage(footerLogo.data, 'PNG', pad, footY + 14, fw, fh);
        }

        if (footerText) {
          doc.setFont(FONT_MONO, 'normal');
          doc.setFontSize(7);
          doc.setTextColor(0);

          const charSpace = 0.5;
          const text = footerText.toUpperCase();
          const lines = text.includes('\n')
            ? text
                .split('\n')
                .map((s) => s.trim())
                .filter(Boolean)
            : doc.splitTextToSize(text, 260);

          // charSpace breaks jsPDF's align:'right' width math — right-align manually
          let fy = footY + 33;
          lines.forEach((line) => {
            const lw =
              doc.getTextWidth(line) + charSpace * Math.max(line.length - 1, 0);
            doc.text(line, W - pad - lw, fy, { charSpace });
            fy += 13;
          });
        }

        doc.save('Pick-Your-Powers-Summary.pdf');
      })
      .catch((err) => {
        console.error('PDF generation failed', err);
      });
  }

  document.addEventListener('click', (e) => {
    if (e.target.closest('.js-pdf-download')) {
      e.preventDefault();
      generatePDF();
    }

    const card = e.target.closest('.pdf-card');
    if (card) {
      const radio = card.querySelector('input[type="radio"]');
      if (radio && !radio.checked) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  });
})();
